import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import allActions from "../actions/allActions";
import * as cState from "./certReducer";
import { TemplateCard } from "./components/TemplateCard";
import { PostmarkCard } from "./components/PostmarkCard";
import Tab from "../components/tabs/Tab";
import { Tabs } from "../components/tabs/Tabs";
import { Route, useLocation, useParams, useRouteMatch } from "react-router-dom";
import { ConfirmSend } from "./components/ConfirmSend";
import Loading from "../components/utils/Loading";
import { useFormatMessage } from "../utils/functions";
import CertParticipantTable from "./certParticipantTable/CertParticipantTable";
import BreadCrumb from "../components/breadcrumbs/BreadCrumb";
import { BreadRoute } from "../components/breadcrumbs/BreadRoute";
import { CertParamTypes } from "../types/types";

export const EditCert: React.FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { path, url } = useRouteMatch();
  const [activeTab, setActiveTab] = useState(null);
  const { certOperationId, mailId } = useParams<CertParamTypes>();
  const { isLoading, participants, selectedTemplate } = useSelector(
    cState.getCertPageData
  );
  const certTab = useFormatMessage("Cert.Tabs.Cert");
  const mailTab = useFormatMessage("Cert.Tabs.Mail");
  const confirmTab = useFormatMessage("Cert.Tabs.Send");
  const participantTab = useFormatMessage("Cert.Tabs.Participants");
  const headerRow =
    participants.length > 0
      ? Object.keys(participants[0]).length > 5
        ? Object.keys(participants[0]).slice(0, 5)
        : Object.keys(participants[0])
      : [];
  const crumbs = [
    { label: "certmenu", link: "/certmenu" },
    { label: "certs", link: "/certs" },
    { label: `cert ${certOperationId}`, link: `/certs/${certOperationId}` },
    { label: `mail ${mailId}`, link: `/certs/${certOperationId}/${mailId}` },
  ];

  const handleInputChange = (e: any, id: string) => {
    dispatch(allActions.formActions.updateValue(id, e.target.value, "newCert"));
  };

  const getActiveTab = useCallback(() => {
    const pathArray = location.pathname.split("/");
    return pathArray.length === 5
      ? setActiveTab(certTab)
      : setActiveTab(pathArray[pathArray.length - 1]);
  }, [location, certTab]);

  useEffect(() => {
    getActiveTab();
  }, [getActiveTab]);

  return (
    <div className='container w-screen h-full'>
      <BreadRoute>
        {crumbs.map((c, i) => {
          const last = i + 1 === crumbs.length;
          return (
            <BreadCrumb
              key={c.link}
              label={c.label}
              link={c.link}
              lastChild={last}
            />
          );
        })}
      </BreadRoute>
      <Tabs>
        <Tab activeLabel={activeTab} label={certTab} link={`${url}`} />
        <Tab
          activeLabel={activeTab}
          label={mailTab}
          link={`${url}/${mailTab}`}
        />
        <Tab
          activeLabel={activeTab}
          label={confirmTab}
          link={`${url}/${confirmTab}`}
        />
      </Tabs>
      <div className='container h-full max-h-11/12 w-full flex justify-center items-center border-r border-l border-b border-gray-400 overflow-auto scroller'>
        {isLoading ? (
          <Loading />
        ) : (
          <>
            <Route
              path={`${path}/${participantTab}`}
              render={() => (
                <CertParticipantTable
                  list={participants}
                  headerRow={headerRow}
                />
              )}
            />
            <Route
              exact
              path={path}
              render={() => (
                <TemplateCard
                  templateName={selectedTemplate}
                  handleInputChange={handleInputChange}
                />
              )}
            />
            <Route
              path={`${path}/${mailTab}`}
              render={() => (
                <PostmarkCard
                  templateName={selectedTemplate}
                  handleInputChange={handleInputChange}
                />
              )}
            />
            <Route
              path={`${path}/${confirmTab}`}
              render={() => <ConfirmSend templateName={selectedTemplate} />}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default EditCert;
